import { render, staticRenderFns } from "./lamsRegLegalOpinion.vue?vue&type=template&id=698c2373&scoped=true&"
import script from "./lamsRegLegalOpinion.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalOpinion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698c2373",
  null
  
)

export default component.exports